export default __webpack_public_path__ + "static/media/openpitrix.ad3a4ebc.svg";